import React, { useState, useContext } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSignOutAlt,
  faExchangeAlt,
  faCog,
  faBars,
  faTimes,
  faSearch
} from '@fortawesome/free-solid-svg-icons'
import { isEmpty, isUndefined } from 'lodash'
import NavDropdown from 'react-bootstrap/NavDropdown'
import UserContext from 'context/user-context'
import { useAhoy } from 'context/ahoy-context'
import AppSwitcher from 'layout/app-switcher'
import { hasMultipleApps } from 'layout/app-access'
import { InputGroup, Form } from 'react-bootstrap'
import SearchModal from 'layout/access-management/search-modal'
import MunicipalitySwitcher from 'layout/municipality-switcher'
import { canSwitchMunicipality } from 'utils/municipality-access'
import ShieldLogo from 'assets/Shield/White/ThirdLine Shield White.svg'
import { useSidebar } from '../sidebar-context'
import SidebarToggleIcon from '../sidebar-toggle-icon'

function Navbar({ logo, title, subtitle, withSearch = true }) {
  const { logout } = useAuth0()
  const { clearVisit } = useAhoy()
  const currentUser = useContext(UserContext)
  const [show, setShow] = useState(false)
  const [showSwitcher, setShowSwitcher] = useState(false)
  const { isCollapsed, toggleCollapsed, openMobile, closeMobile, mobileOpen, isMobile } = useSidebar()

  const firstName = isUndefined(currentUser.first_name) ? '' : currentUser.first_name
  const lastName = isUndefined(currentUser.last_name) ? '' : currentUser.last_name
  const fullName = `${firstName} ${lastName}`.trim() || 'User'

  return (
    <nav
      className={`navbar navbar-dark fixed-top bg-primary flex-md-nowrap p-0 shadow-sm app-navbar app-navbar-dark ${
        isCollapsed ? 'app-navbar-collapsed' : ''
      }`}
      style={{ minHeight: '54px' }}
    >
      <div
        className="navbar-brand bg-primary app-navbar-brand m-0"
        style={{ minHeight: '54px' }}
      >
        <a
          className="app-navbar-logo d-inline-flex align-items-center"
          href="/duties"
          aria-label="ThirdLine home"
        >
          <img
            src={isCollapsed && !isMobile ? ShieldLogo : logo}
            className="img-fluid"
            alt="ThirdLine Logo"
            style={{ maxHeight: '30px' }}
          />
        </a>

        <button
          type="button"
          className="d-none d-md-inline-flex align-items-center justify-content-center sidebar-collapse-toggle"
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          aria-pressed={isCollapsed}
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          onClick={toggleCollapsed}
        >
          <SidebarToggleIcon />
        </button>
      </div>

      <div className="container-fluid">
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn btn-link d-md-none p-2 me-1 sidebar-mobile-toggle"
            aria-label={mobileOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={mobileOpen}
            onClick={mobileOpen ? closeMobile : openMobile}
          >
            <FontAwesomeIcon icon={mobileOpen ? faTimes : faBars} size="lg" />
          </button>

          <h5 className="text-left mb-0 ms-1 text-light app-navbar-title d-none d-md-block">
            {title}
            {!isEmpty(subtitle) && <small className="ms-2">{subtitle}</small>}
          </h5>
        </div>

        <div className="d-flex">
          {withSearch && !isMobile && (
            <InputGroup
              className="my-auto me-4"
              style={{ cursor: 'pointer', minWidth: '300px' }}
              size="sm"
            >
              <InputGroup.Text
                id="global-search"
                className="bg-light"
                style={{ cursor: 'pointer' }}
              >
                <FontAwesomeIcon icon={faSearch} />
              </InputGroup.Text>
              <Form.Control
                style={{ cursor: 'pointer' }}
                placeholder="Search"
                aria-label="Search"
                aria-describedby="global-search"
                onClick={() => setShow(true)}
                className="bg-light"
                readOnly
              />
            </InputGroup>
          )}
          {/* 'sod' is the backend app key; UI label is 'Access Management' */}
          {hasMultipleApps(currentUser) && <AppSwitcher currentApp={'sod'} />}
          <ul className="navbar-nav px-2">
            <NavDropdown
              id="access-management-nav-dropdown"
              title={isMobile ? <FontAwesomeIcon icon={faCog} /> : fullName}
              align="end"
              className="text-white"
            >
              {canSwitchMunicipality(currentUser) && (
                <>
                  <NavDropdown.Item disabled className="text-muted small">
                    {currentUser.municipality_name}
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => setShowSwitcher(true)}>
                    <FontAwesomeIcon icon={faExchangeAlt} /> Change Municipality
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                </>
              )}
              <NavDropdown.Item href="/settings">
                <FontAwesomeIcon icon={faCog} /> Settings
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => {
                  clearVisit()
                  logout({ returnTo: window.location.origin })
                }}
              >
                <FontAwesomeIcon icon={faSignOutAlt} /> Sign out
              </NavDropdown.Item>
            </NavDropdown>
          </ul>
        </div>
      </div>
      {withSearch && (
        <SearchModal show={show} handleClose={() => setShow(false)} />
      )}
      {canSwitchMunicipality(currentUser) && (
        <MunicipalitySwitcher
          show={showSwitcher}
          onHide={() => setShowSwitcher(false)}
        />
      )}
    </nav>
  )
}

export default Navbar
